import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');


// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll >= 30) {
      $(".m-header__sticky-container").addClass("is-overlaying");
  } else {
      $(".m-header__sticky-container").removeClass("is-overlaying");
  }
});

require('slick-carousel');
$('[data-slick-hero-slider]').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  fade: true,
  arrows: true,
  autoplay: true,
  dots: false,
  mobileFirst: true,
  infinite: true,
});
$('[data-slick-cards]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 500,
    arrows: false,
    autoplay: false,
    dots: true,
    mobileFirst: true,
    infinite: true,
    centerMode: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
          initialSlide: 0,
          centerMode: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          initialSlide: 0,
          arrows: true,
        }
      }
    ]
});
$('[data-slick-cards-generic]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 500,
    arrows: false,
    autoplay: false,
    dots: true,
    mobileFirst: true,
    infinite: true,
    centerMode: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
          initialSlide: 0,
          centerMode: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          initialSlide: 0,
          arrows: true,
        }
      }
    ]
});
$('[data-slick-cards-generic-two-cols]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    speed: 500,
    arrows: false,
    autoplay: false,
    dots: false,
    mobileFirst: true,
    infinite: true,
    centerMode: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
          initialSlide: 0,
          centerMode: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          initialSlide: 0,
          arrows: false,
        }
      }
    ]
});
$('[data-slick-card-pictures]').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 1500,
  fade: true,
  arrows: false,
  autoplay: true,
  dots: false,
  mobileFirst: true,
  infinite: false,
});
$('[data-slick-items]').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  arrows: false,
  autoplay: false,
  dots: false,
  mobileFirst: true,
  infinite: true,
  centerMode: true,
  responsive: [
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2,
        }
      },
      {
          breakpoint: 1024,
          // settings: "unslick"
          settings: {
            slidesToShow: 2
          }
        }
  ]
});

$('[data-slick-crooked-pictures]').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  fade: true,
  arrows: true,
  autoplay: false,
  dots: false,
  mobileFirst: true,
  infinite: true,
  centerMode: true,
  // centerModePadding: '-90%',
});

$('.m-important-listing-row__slide-prev').click(function(e){ 
  //e.preventDefault(); 
  $('[data-slick-items]').slick('slickPrev');
} );

$('.m-important-listing-row__slide-next').click(function(e){
//e.preventDefault(); 
  $('[data-slick-items]').slick('slickNext');
} );

//Map switch
$('[data-switch-map]').click(function(e){ 
  if ($('.leaflet-container').length <= 0) {
    var thisEl = $(this);
    setTimeout(function() {
      // Creating map options
      var location = thisEl.data('location').split(', ');
      var mapOptions = {
        center: [location[0], location[1]],
        zoom: 14,
        zoomControl: false
      }
      
      // Creating a map object
      var map = new L.map('map', mapOptions);

      // Addd marker
      var blackIcon = new L.Icon({
          iconUrl: '/svg/icon-poi.svg',
          iconSize: [34, 46],
          iconAnchor: [17, 60],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
      });
      L.marker([location[0], location[1]], {icon: blackIcon}).addTo(map);
      
      // Creating a Layer object
      var layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
      
      // Adding layer to the map
      map.addLayer(layer);
    }, 100);
  }

  var element = document.getElementById("map");
  var elementSwitchMap = $('.m-hero-slider__map-switch')[0];
  var elementSwitchVisual = $('.m-hero-slider__visual-switch')[0];
  element.classList.add("show");
  elementSwitchVisual.classList.add("show");
  elementSwitchMap.classList.remove("show");
} );

$('[data-switch-visual]').click(function(e){ 
  var element = document.getElementById("map");
  var elementSwitchMap = $('.m-hero-slider__map-switch')[0];
  var elementSwitchVisual = $('.m-hero-slider__visual-switch')[0];
  element.classList.remove("show");
  elementSwitchMap.classList.add("show");
  elementSwitchVisual.classList.remove("show");
} );



// m-component-img-box
$('[data-img-box-card]').click(function(e){

  // Get index sel
  const INDEX = parseInt($(this).attr('data-img-box-card'));

  // Change item selected
  $(this).closest('.m-component-img-box').find(".item-container").each(function(){
    $(this).find(".item").removeClass("selected");
  })
  $(this).find(".item").addClass("selected");

  // Update card selected
  const CARDS = $(this).closest('.m-component-img-box').find(".m-component-img-box__cards-container__card");
  $(this).closest('.m-component-img-box').find(".m-component-img-box__cards-container__card").each(function(i){
    if (i == INDEX)
    {
      $(this).find('.m-component-img-box__cards-container__card__img').addClass("selected");
    }
    else
    {
      $(this).find('.m-component-img-box__cards-container__card__img').removeClass("selected");
    }
  });

  // Move slider
  $(this).closest('.m-component-img-box').attr("data-current", INDEX);
});


// m-card-flex
function slick_list_title_container()
{
  $('.slick-list').each(function(){
  
    const CURRENT_SLICK = $(this);
    const CARDS = CURRENT_SLICK.find('.m-card-flex');
    let MAX_HEIGHT = 0;
  
    // Get cards
    CARDS.each(function(){
  
      const CURRENT_CARD = $(this);
      const TITLE = CURRENT_CARD.find('.m-card-flex__text-container');
      const TITLE_H = TITLE.height();
    
      TITLE.css("margin-top", `-${TITLE_H}px`);
  
      if (TITLE_H > MAX_HEIGHT)
      {
        MAX_HEIGHT = TITLE_H;
      }
    })
  
    // Set margin top
    CURRENT_SLICK.css("margin-top", `${MAX_HEIGHT}px`);
    CURRENT_SLICK.css("margin-bottom", `100px`);
  })
}

slick_list_title_container();
$(window).resize(function(){
  slick_list_title_container();
})

// Map Accomodation Page (new UI)
let map_accomodation;
function show_map_accomodation_map()
{
  $('[data-accomodation-map]').each(function(e){ 
    var thisEl = $(this);
    setTimeout(function() {
      
      // Creating map options
      var location = thisEl.data('location').split(', ');
      var mapOptions = {
        center: [location[0], location[1]],
        zoom: 14,
        zoomControl: true
      }
      
      // Creating a map object
      map_accomodation = new L.map('accomodation-map', mapOptions);
  
      // Addd marker
      var blackIcon = new L.Icon({
          iconUrl: '/svg/icon-poi.svg',
          iconSize: [34, 46],
          iconAnchor: [17, 60],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
      });
      L.marker([location[0], location[1]], {icon: blackIcon}).addTo(map_accomodation);
      
      // Creating a Layer object
      var layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
      
      // Adding layer to the map
      map_accomodation.addLayer(layer);
    }, 100);
  });
}
show_map_accomodation_map();

// Show/Hide map mobile accomodation
$('[data-show-map-accmodation-mobile]').click(function(){

  if ($(this).hasClass("show-mobile"))
  {
    $(this).removeClass("show-mobile");
    $("#accomodation-map").removeClass("show-mobile");
  }
  else
  {
    $(this).addClass("show-mobile");
    $("#accomodation-map").addClass("show-mobile");
  }

  // Reset map with new sizes
  map_accomodation.remove();
  show_map_accomodation_map();
})


// Map List Scroll Trigger
if ($('.trigger-list-map').length)
{
  $(window).scroll(function() {
    
    const SCROLL_TOP = $(document).scrollTop();
    const ITEM_OFFSET_TOP_FIRST = $('.trigger-list-map').find('.m-card__href:first-child').offset().top - 195;
    $('.trigger-list-map').find('.m-card__href').each(function(){

      const CURRENT_OFFSET_TOP = $(this).offset().top - ITEM_OFFSET_TOP_FIRST;
      const CURRENT_OFFSET_END = CURRENT_OFFSET_TOP + $(this).height();
      if (
        SCROLL_TOP > CURRENT_OFFSET_TOP 
        && SCROLL_TOP < CURRENT_OFFSET_END
      )
      {
        $(this).trigger( "mouseover" );
      }
    })
  })
}